module.exports = __webpack_public_path__ + "static/media/MajooCRM10.1c2e0d5a.png";